import { createFileRoute } from "@tanstack/react-router";

import { TrustDocumentPage } from "@/components/legal/trust-document-page";
import { multiResumeBrand } from "@/utils/multiresume-brand";

export const Route = createFileRoute("/terms")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: `Terms - ${multiResumeBrand.appName}` }],
  }),
});

function RouteComponent() {
  return <TrustDocumentPage documentKey="terms" />;
}
